import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamAngularDiameter = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M12.4463 4.01172C14.6419 4.12293 16.6205 5.05262 18.0869 6.5L20.2744 4.31348C20.4697 4.11821 20.7862 4.11821 20.9814 4.31348C21.1767 4.50874 21.1767 4.82526 20.9814 5.02051L18.7588 7.24219C19.9523 8.72721 20.667 10.6135 20.667 12.667L20.6562 13.1123C20.4243 17.6916 16.6378 21.3328 12.001 21.333L11.5547 21.3223C9.67445 21.227 7.95393 20.5305 6.57715 19.4238L4.35547 21.6465C4.16022 21.8417 3.84369 21.8417 3.64844 21.6465C3.45319 21.4512 3.45321 21.1347 3.64844 20.9395L5.83301 18.7539C4.38573 17.2874 3.45692 15.3079 3.3457 13.1123L3.33398 12.667C3.33398 7.88052 7.21451 4 12.001 4L12.4463 4.01172ZM7.28906 18.7119C8.5893 19.7266 10.2239 20.333 12.001 20.333C16.2349 20.3328 19.6668 16.9009 19.667 12.667C19.667 10.8899 19.0606 9.25531 18.0459 7.95508L7.28906 18.7119ZM12.001 5C7.76679 5 4.33398 8.43281 4.33398 12.667C4.33407 14.7638 5.17689 16.6629 6.54102 18.0469L17.3809 7.20703C15.9969 5.8429 14.0977 5.00009 12.001 5Z",
			fill: "var(--fill-0, #DFCBF5)",
			fillOpacity: .7
		})
	})
});
export default SvgParamAngularDiameter;
